var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1413 20.9798C27.0961 16.0796 31.2565 13.6956 31.4467 13.5847C29.0905 10.2352 25.4385 9.77761 24.1551 9.74112C21.0878 9.4264 18.1125 11.5306 16.5501 11.5306C14.9564 11.5306 12.5503 9.77152 9.95704 9.82322C6.61999 9.87339 3.49813 11.7571 1.78594 14.6824C-1.74759 20.6468 0.887745 29.4119 4.27314 34.233C5.96661 36.5942 7.94545 39.2305 10.5356 39.1378C13.0695 39.0359 14.0161 37.5626 17.074 37.5626C20.1039 37.5626 20.9927 39.1378 23.6343 39.0785C26.3538 39.0359 28.066 36.7067 29.7002 34.3242C31.6572 31.6179 32.4432 28.9527 32.4743 28.8159C32.4104 28.7946 27.1928 26.8531 27.1413 20.9798Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1513 6.56959C23.5142 4.90781 24.4467 2.647 24.1878 0.352737C22.2152 0.437879 19.7483 1.68307 18.3277 3.30837C17.0709 4.74057 15.9481 7.08804 16.2382 9.29564C18.454 9.45681 20.7292 8.20553 22.1513 6.56959Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).804fa46fe4774dc1f88e3f4a95c1afe2.svg";
export { ForwardRef as ReactComponent };